import React from "react";
import Amenities from "components/Amenities.js";
import AnimationRevealPage from "components/AnimationRevealPage.js";
import CardSlider from "components/HomesSlider.js";
import FAQ from "components/Faq.js";
import Footer from "components/Footer.js";
import Header from "components/Header.js";
import Hero from "components/Hero.js";
import Posts from "components/Posts.js";
import RegisterUser from "components/RegisterUser.js";
import PendingUser from "components/PendingUser.js";

import AuthContext from 'contexts/AuthContext';

export default () => {
  const {role} = React.useContext(AuthContext);
  return (<>
    <AnimationRevealPage>
      <Header />
      <Hero />
      {role === "ADMIN" && <Posts />}
      <CardSlider />
      <Amenities />
      <FAQ />
      <Footer />
    </AnimationRevealPage>
    {role === "REGISTER" && <RegisterUser />}
    {role === "USER" && <PendingUser />}
  </>);
}
